import find from 'lodash/find';

export const YES_NO_TYPE = 1;
export const TEXT_INPUT_TYPE = 2;
export const WEEKS_TYPE = 3;


export const groupScoreCalc = (group, questions) => {

    // let result = null

    // switch(group) {
    //     case 'STRATEGY & COMMITMENT':
    //         (questions['PRP-1'].score * 0.3) + (0.3 * questions['PRP-2'].score) + (questions['PRP-3'].score *  0.4)
    //         break;
    //     case 'TALENT DIVERSITY':
    //         (questions['PRP-4'].score * 0.3) + (0.3 * questions['PRP-10'].score) + (questions['PRP-9'].score *  0.4)
    //         break;
    //     case 'WORKPLACE INCLUSIVITY':
    //         (questions['B&C-10'].score * 0.2) + (0.15 * questions['PRP-5'].score) + (0.15 * questions['PRP-6'].score)  + (0.15 * questions['PRP-7'].score) + (0.2 * questions['PRP-8'].score) + (0.15 * questions['GRO-7'].score) 
    //         break;
    //     case 'ENGAGEMENT & COMMUNICATION':
    //         (questions['PRP-11'].score * 0.3) + (0.3 * questions['PRP-12'].score) + (0.1 * questions['B&C-4'].score)  + (0.1 * questions['B&C-5'].score) + (0.1 * questions['B&C-6'].score) + (0.1 * questions['B&C-7'].score) 
    //         break;

    // }


    // let total_score = (score['STRATEGY & COMMITMENT'] * 0.3) +  (score['TALENT DIVERSITY'] * 0.2) + (score['WORKPLACE INCLUSIVITY'] * 0.3) +  (score['ENGAGEMENT & COMMUNICATION'] * 0.2)

}


export const questionsProcessAndPolicies = [
  {
    kpiId : 'PRP-1',
    type : 'Strategy',
    category:'Processes & Policies',
    group:'STRATEGY & COMMITMENT',
    questions : [
      {
        text : 'Does the organization currently have a documented talent management strategy?',
        optionsType : YES_NO_TYPE,
        score : 3,
        isMM:true,
      },
      {
        text : 'Does the organization currently have a documented process to implement the talent management strategy?',
        optionsType : YES_NO_TYPE,
        score : 3,
        isMM:true,
      },
      {
        text : 'Does the organization currently have a documented strategy to support a respectful and fair workplace for all employees?',
        optionsType : YES_NO_TYPE,
        score : 3,
        isMM:true,
      },
      {
        text : 'Does the organization have a documented process to carry out this strategy?',
        optionsType : YES_NO_TYPE,
        score : 3,
        isMM:true,
      }
    ]
  },
  {
    kpiId : 'PRP-2',
    type : 'Infrastructure',
    category:'Processes & Policies',
    group:'STRATEGY & COMMITMENT',
    questions : [
      {
        text : 'Does the organization currently have assigned staff responsible for leading efforts that support a respectful and fair workplace for all employees?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true,
      },
      {
        text : 'Does the organization have a senior executive with a specific function of managing these efforts?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true,
      },
      {
        text : 'Does this senior executive report directly to the CEO or President?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true,
      },
      {
        text : 'Does the organization currently have an allocated annual budget for efforts that support a respectful and fair workplace for all employees?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true,
      }
    ]
  },
  {
    kpiId : 'PRP-3',
    type : 'Accountability',
    category:'Processes & Policies',
    group:'STRATEGY & COMMITMENT',
    questions : [
      {
        text : 'Does the organization currently task and measure progress of executives and managers towards creating a respectful and fair workplace?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true,
      },
      {
        text : 'Does progress towards meeting these goals currently influence performance evaluation for executives and managers?s?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true,
      },
      {
        text : 'Does the organization currently task and measure progress of supervisors/front-line managers towards creating a respectful and fair workplace?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true,
      },
      {
        text : 'Does progress towards meeting these goals currently influence performance evaluation for supervisors/front-line managers?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true,
      },
      {
        text : 'Does the organization currently have a clear, trusted process for raising concerns related to respect and fairness in the workplace?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true,
      },
      {
        text : 'Does the organization currently have a defined process to follow up and take action on concerns related to respect and fairness in the workplace?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true,
      },
      {
        text : 'In the most recent 12 months, has the organization conducted a compensation audit to ensure fairness, accuracy, and compliance of the compensation practices?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true,
      }
    ]
  },
  {
    kpiId : 'PRP-4',
    type : 'Training & Development',
    category:'Processes & Policies',
    group:'TALENT DIVERSITY',
    questions : [
      {
        text : 'In the most recent 12 months, has the organization conducted and/or sponsored leadership programs designed to address the unique needs of all employees from different backgrounds and communities?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, has the organization had mentorship programs designed to address the unique needs of all employees from different backgrounds and communities?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, has the organization developed career growth plans designed to address the unique needs of all employees from different backgrounds and communities?  ',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, has the organization conducted and/or sponsored training for executives and managers on building a respectful and fair workplace culture?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, has the organization conducted and/or sponsored training for supervisors/front-line managers on building a respectful and fair workplace culture?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, has the organization trained decision makers at all levels to better understand the communities they serve and operate in, and the impact their decisions may have on these groups?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      }
    ]
  },
  {
    kpiId : 'PRP-10',
    type : 'Fair Merit-based Recruiting',
    category:'Processes & Policies',
    group:'TALENT DIVERSITY',
    questions : [
      {
        text : 'Does the organization currently use a specific, defined recruiting strategy to ensure a fair merit-based process that removes barriers for candidates from the full range of communities it serves and operates in?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true
      },
      {
        text : 'Does the organization currently leverage sourcing channels designed to reduce barriers and improve access for candidates from the full range of communities it serves and operates in?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'Does the organization currently require that candidate slates for open roles reflect the full range of qualified talent from all communities it serves and operates in?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true
      },
      {
        text : 'Does the organization currently require that interview panels for management and executive roles reflect the full range of communities it serves and operates in?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'Does the organization currently have a program for recruiting employees looking to transition back to the workforce after taking a career break?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      }
    ]
  },
  {
    kpiId : 'PRP-9',
    type : 'Leadership Alignment',
    category:'Processes & Policies',
    group:'TALENT DIVERSITY',
    questions : [
      {
        text : 'Is the organization’s current Board Chair or Lead Independent Director position held by someone with the full range of perspectives and experiences of the communities the organization serves and operates in?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'Is the organization’s current CEO or equivalent position held by someone with the full range of perspectives and experiences of the communities the organization serves and operates in?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'Are there currently visible role models that reflect the full range of perspectives and experiences of the communities the organization serves and operates in at the C-suite and Executive levels?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'Are there currently visible role models that reflect the full range of perspectives and experiences of the communities the organization serves and operates in at the Managerial level?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'Are there currently visible role models that reflect the full range of perspectives and experiences of the communities the organization serves and operates in at the Supervisory level?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      }
    ]
  },
  {
    type : 'Employee Inclusivity & Belonging',
    kpiId : 'B&C-10',
    category:'Business & Culture',
    group:'WORKPLACE INCLUSIVITY',
    questions : [{
      text : 'What % of employees would say they feel they are included and belong in the organization?',
      optionsType : TEXT_INPUT_TYPE	,
      isMM:true
    }]
  },
  {
    kpiId : 'PRP-5',
    type : 'Parental Leave',
    category:'Processes & Policies',
    group:'WORKPLACE INCLUSIVITY',
    questions : [
      {
        text : 'What is the minimum fully paid maternity leave currently available to employees?',
        optionsType : WEEKS_TYPE,
        isMM:true,
        score:3
      },
      {
        text : 'What is the minimum fully paid paternity leave currently available to employees?',
        optionsType : WEEKS_TYPE,
        isMM:true,
        score:3
      },
    ]
  },
  {
    kpiId : 'PRP-6',
    type : 'Family/Elder Care',
    category:'Processes & Policies',
    group:'WORKPLACE INCLUSIVITY',
    questions : [
      {
        text : 'Does the organization currently provide backup family/elder care?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true
      },
      {
        text : 'Does the organization currently provide a subsidy for family/elder care?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true
      },
      {
        text : 'Does the organization currently provide on-site child care?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true
      },
      {
        text : 'Does the organization currently provide referral services for family/elder care?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true
      },
      {
        text : 'Does the organization currently provide other family/elder care?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true
      }
    ]
  },
  {
    kpiId : 'PRP-7',
    type : 'Work Flexibility',
    category:'Processes & Policies',
    group:'WORKPLACE INCLUSIVITY',
    questions : [
      {
        text : 'Does the organization currently offer an option to control and/or vary the start/end times of the workday or workweek (e.g. flextime)?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true
      },
      {
        text : 'Does the organization currently offer an option to control and/or vary the location where employees work from (e.g. telecommuting)?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true
      },
      {
        text : 'Does the organization currently have a re-entry, on-boarding, or specific support program for employees returning from maternity, paternity, and/or other family leave?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true
      }
    ]
  },
  {
    kpiId : 'PRP-8',
    type : 'Sexual Harassment',
    category:'Processes & Policies',
    group:'WORKPLACE INCLUSIVITY',
    questions : [
      {
        text : 'Does the organization  currently have a hotline where anyone can anonymously raise issues and submit complaints?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true
      },
      {
        text : 'Does the organization currently have a sexual harassment policy?',
        optionsType : YES_NO_TYPE,
        score : 2,
        isMM:true
      },
      {
        text : 'Does the organization currently utilize an impartial third-party investigator to evaluate all sexual harassment allegations? ',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'Does the organization currently prohibit inclusion of a confidentiality provision (or silencing agreement) in sexual harassment settlement agreements?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      }
    ]
  },
  {
    type : 'Mentorship',
    kpiId:'GRO-7',
    category : 'Employee Lifecycle',
    group:'WORKPLACE INCLUSIVITY',
    questions : [
      {
        text : 'What % of executives and managers have mentors?',
        optionsType : TEXT_INPUT_TYPE,
        isMM:true
      }
    ]
  },
  {
    kpiId : 'PRP-11',
    type : 'Workplace Culture Advocacy',
    category:'Processes & Policies',
    group:'ENGAGEMENT & COMMUNICATION',
    questions : [
      {
        text : 'In the most recent 12 months, has the organization communicated information about its respectful and fair workplace goals with employees?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, has the organization communicated information about its respectful and fair workplace goals externally?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },{
        text : 'In the most recent 12 months, has the organization advocated more broadly (i.e., beyond itself) about respect and fairness in the workplace?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, has the CEO personally advocated for a respectful and fair workplace internally?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, has the CEO personally advocated for a respectful and fair workplace externally?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, has the organization, CEO, Chairperson, or equivalent given monetary support to any non-profit organization(s) with a primary mission of advocating and promoting respect and fairness in the workplace?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, has the organization applied for awards recognizing its efforts to create a respectful and fair workplace?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, has the organization won any awards recognizing its efforts to create a respectful and fair workplace?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, has the organization conducted an employee engagement survey?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the employee engagement survey, conducted in the most recent 12 months, were specific questions around a respectful and fair workplace included?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'For the employee engagement survey which included those questions conducted in the most recent 12 months, were action items generated and worked on?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      }
    ]
  },
  {
    kpiId : 'PRP-12',
    type : 'Resources & Support',
    category:'Processes & Policies',
    group:'ENGAGEMENT & COMMUNICATION',
    questions : [
      {
        text : 'Does the organization currently have affinity networks or employee groups?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'Are the affinity networks or employee groups currently sponsored by an Executive?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      },
      {
        text : 'In the most recent 12 months, have executives regularly and actively participated in events or activities of the affinity networks or employee groups?',
        optionsType : YES_NO_TYPE,
        score : 1,
        isMM:true
      }
    ]
  }
]

export const questionsBusinessCulture = [
  {
    type : 'Mission Alignment',
    kpiId : 'B&C-4',
    category:'Business & Culture',
    group:'ENGAGEMENT & COMMUNICATION',
    questions : [{
      text : 'What % of employees would say they fully understand and support the organization\'s mission?',
      optionsType : TEXT_INPUT_TYPE,
      isMM:true,
      
    }]
  },
  {
    type : 'Employee Engagement',
    kpiId : 'B&C-5',
    category:'Business & Culture',
    group:'ENGAGEMENT & COMMUNICATION',
    questions : [{
      text : 'What % of employees would say they feel they are fully contributing towards the organization\'s mission?',
      optionsType : TEXT_INPUT_TYPE,
      isMM:true
    }]
  },
  {
    type : 'Employee Dedication',
    kpiId : 'B&C-6',
    category:'Business & Culture',
    group:'ENGAGEMENT & COMMUNICATION',
    questions : [{
      text : 'What % of employees would say the organization motivates them to go beyond what they would in a similar role elsewhere?',
      optionsType : TEXT_INPUT_TYPE,
      isMM:true
    }]
  },
  {
    type : 'Employee Endorsement',
    kpiId : 'B&C-7',
    category:'Business & Culture',
    group:'ENGAGEMENT & COMMUNICATION',
    questions : [{
      text : 'What % of employees would  say they recommend their organization as a great place to work?',
      optionsType : TEXT_INPUT_TYPE,
      isMM:true
    }]
  },
  // {
  //   type : 'Employee Loyalty',
  //   kpiId : 'B&C-8',
  //   category:'Business & Culture',
  //   questions : [{
  //     text : 'What % of employees would say they see themselves working at the organization in 2 years time?',
  //     optionsType : TEXT_INPUT_TYPE
  //   }]
  // },
  // {
  //   type : 'Employee Commitment',
  //   kpiId : 'B&C-9',
  //   category:'Business & Culture',
  //   questions : [{
  //     text : 'What % of employees would say they rarely look for a job elsewhere?',
  //     optionsType : TEXT_INPUT_TYPE	
  //   }]
  // },
 
]

export const questionsEmployeeLifecycle = [
  
]

export const questionsBoard = [
  // {
  //   kpiId : 'REP-2',
  //   type : 'Board Makeup',
  //   category:'Board',
  //   group:'TALENT DIVERSITY',
  //   questions : [
  //     {
  //       text : 'Currently what % of members of the Board of Directors are women and/or members of underrepresented groups?',
  //       optionsType : TEXT_INPUT_TYPE,
  //       isMM:false
  //     }
  //   ]
  // }
]

export const getKpiNameByCode = (code) => {
  const allQuestions = questionsEmployeeLifecycle.concat(questionsBusinessCulture)
  .concat(questionsProcessAndPolicies).concat(questionsBoard);
  return find(allQuestions,(o) => o.kpiId === code).type;
}

export const maturity_model_questions_cats_wise = [...questionsProcessAndPolicies,...questionsBusinessCulture]

